import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-263002cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "media" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle([_ctx.youtubeLink ? { display: 'flex' } : { display: 'none' }])
    }, [
      _createElementVNode("iframe", {
        src: _ctx.formatYoutubeLink(this.youtubeLink),
        class: "youtube-player",
        frameborder: "0",
        allow: "accelerometer; \n                    clipboard-write; \n                    gyroscope; \n                    picture-in-picture"
      }, "\n      ", 8, _hoisted_2)
    ], 4),
    _createElementVNode("div", {
      style: _normalizeStyle([_ctx.spotifyLink ? { display: 'flex' } : { display: 'none' }])
    }, [
      _createElementVNode("iframe", {
        src: `https://open.spotify.com/embed/artist/${this.spotifyLink}?utm_source=generator`,
        class: "spotify-player",
        frameBorder: "0",
        allowfullscreen: "",
        allow: "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      }, "\n      ", 8, _hoisted_3)
    ], 4)
  ]))
}